import zod from 'zod'
import {
  displayNameValidator,
  usernameValidator,
  pronounsValidator,
  locationValidator,
} from '../../validators'
import { userProfileLimits, limitsText } from '../../constants/limits'

export const birthdaySchema = zod.object({
  show: zod.boolean(),
  dateOnly: zod.boolean(),
  date: zod.date().optional().nullable(),
})

export const profileFormSchema = (showInlineError = true) => {
  const userNameSchema = usernameValidator({ showInlineError })

  return zod.object({
    avatarId: zod.string().nullable(),
    headerId: zod.string().nullable(),
    channel: zod.boolean().optional(),
    actorType: zod
      .enum(['Application', 'Group', 'Organization', 'Person', 'Service'])
      .optional(),
    userName: userNameSchema,
    displayName: displayNameValidator,
    Pronouns: pronounsValidator,
    summary: zod
      .string()
      .max(userProfileLimits.description, limitsText.long)
      .optional(),
    customFields: zod.array(
      zod.object({
        label: zod
          .string()
          .max(userProfileLimits.fieldLabel, limitsText.long)
          .optional(),
        content: zod
          .string()
          .max(userProfileLimits.fieldContent, limitsText.long)
          .optional(),
      }),
    ),
    location: zod.object({
      geo: zod
        .object({
          latitude: zod.number().optional(),
          longitude: zod.number().optional(),
          accuracy: zod.number().optional().nullable(),
        })
        .optional()
        .nullable(),
      show: zod.boolean().optional(),
      name: locationValidator,
      autoUpdate: zod.boolean().optional(),
    }),
    timezone: zod.object({
      show: zod.boolean(),
      ianaTimezone: zod.string().optional(),
      autoUpdate: zod.boolean(),
    }),
    birthday: birthdaySchema,
    canSubmit: zod.boolean(),
    botProfile: zod
      .object({
        role: zod.string().optional(),
        triggers: zod
          .array(
            zod.object({
              id: zod.string(),
              label: zod.string(),
            }),
          )
          .optional(),
        personality_traits: zod
          .array(
            zod.object({
              id: zod.string(),
              label: zod.string(),
            }),
          )
          .optional(),
        tone: zod.string().optional(),
        style: zod
          .array(
            zod.object({
              id: zod.string(),
              label: zod.string(),
            }),
          )
          .optional(),
        behaviors: zod
          .array(
            zod.object({
              id: zod.string(),
              label: zod.string(),
            }),
          )
          .optional(),
        prompt: zod.string().optional(),
      })
      .optional(),
  })
}
